import * as React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@mui/material';
import EmploymentForm from './EmploymentForm';

const CareersPage = () => {
    return (
        <div className='page-back py-5'>
            {/* --- Careers Page Content --- */}
            <Box className="container bg-white" style={{ borderRadius: "10px", boxShadow: "0 2px 6px rgba(0,0,0,0.2)"}} sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
                <Typography variant="h4" component="h4" gutterBottom sx={{ color: '#1b8fc9', textAlign: 'center',fontWeight: 'bold',mb: 3 }}>
                    Become a Caregiver with 24/7 Assure Care
                </Typography>
                <Typography variant="body1" paragraph sx={{ padding: '0 40px', fontSize: '1.1rem', lineHeight: 1.6 }}>
                    At 24/7 Assure Care, we are dedicated to providing compassionate and professional care to our clients. 
                    We understand that our caregivers are the heart of our organization, and we're committed to creating a 
                    supportive environment where you can thrive both personally and professionally.
                </Typography>
                <Typography variant="body1" paragraph sx={{ padding: '0 40px', fontSize: '1.1rem', lineHeight: 1.6 }}>
                    If you have a passion for helping others, a commitment to excellence, and the desire to make a real 
                    difference in people's lives, we invite you to join our growing team of healthcare professionals.
                </Typography>
                {/* Benefits Section */}
                <Box sx={{ mt: 5, mb: 4 }}>
                    <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#1b8fc9', textAlign: 'center',mb: 3}}>
                        Why Choose 24/7 Assure Care?
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Competitive Compensation
                                    </Typography>
                                    <Typography variant="body2">
                                        We offer competitive pay rates, overtime opportunities, and performance-based bonuses 
                                        to reward your dedication and hard work.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Flexible Scheduling
                                    </Typography>
                                    <Typography variant="body2">
                                        We understand the importance of work-life balance. Choose from full-time, part-time, 
                                        day, evening, or overnight shifts that fit your lifestyle.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Comprehensive Training
                                    </Typography>
                                    <Typography variant="body2">
                                        Receive ongoing training and professional development opportunities to enhance your 
                                        skills and advance your career in healthcare.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Supportive Team Environment
                                    </Typography>
                                    <Typography variant="body2">
                                        Join a collaborative team that values communication, mutual respect, and shared 
                                        commitment to exceptional patient care.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Professional Development
                                    </Typography>
                                    <Typography variant="body2">
                                        Obtain vast amount of skills working in diverse environments gaining support 
                                        for your future endeavors.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                        Meaningful Work
                                    </Typography>
                                    <Typography variant="body2">
                                        Make a real difference in the lives of individuals and families while building 
                                        rewarding, long-term relationships with your clients.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ mt: 5, mb: 4 }}>
                    <Typography variant="h4" component="h2" gutterBottom
                        sx={{ color: '#1b8fc9', textAlign: 'center', mb: 3 }}>
                        What We're Looking For
                    </Typography>

                    <Grid container spacing={2}>
                        {/* Column 1 */}
                        <Grid item xs={12} md={6}>
                            <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                                Ideal Candidates Possess:
                            </Typography>
                            <ul style={{ paddingLeft: '20px', fontSize: '1.1rem' }}>
                                <li>Compassionate and patient-centered approach to care</li>
                                <li>Previous caregiving experience (preferred but not required)</li>
                                <li>Reliable transportation and valid driver's license</li>
                                <li>Ability to pass background checks and drug screening</li>
                            </ul>
                        </Grid>

                        {/* Column 2 */}
                        <Grid item xs={12} md={6}>
                        <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9', visibility:'hidden' }}>
                            Placeholder
                        </Typography>
                        <ul style={{ paddingLeft: '20px', fontSize: '1.1rem' }}>
                            <li>Strong communication and interpersonal skills</li>
                            <li>CPR/First Aid certification (or willingness to obtain)</li>
                            <li>Commitment to maintaining client confidentiality and privacy</li>
                        </ul>
                        </Grid>
                    </Grid>
</Box>


                {/* Application Form Section */}
                <Box sx={{ mt: 5, p: 3, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                    <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#1b8fc9', textAlign: 'center',mb: 2}}>
                        Ready to Make a Difference?
                    </Typography>
                    
                    <Typography variant="body1" paragraph sx={{ textAlign: 'center', mb: 3 }}>
                        Join our team of dedicated healthcare professionals. Complete the application form below and 
                        our recruitment team will contact you within 3-5 business days to discuss next steps.
                    </Typography>
                    
                    <EmploymentForm />
                </Box>

                {/* Contact Information */}
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography variant="h6" gutterBottom sx={{ color: '#1b8fc9' }}>
                        Questions About Careers at 24/7 Assure Care?
                    </Typography>
                    <Typography variant="body1">
                        Email us at: <a href="mailto:info@247assurecare.com" style={{ color: '#1b8fc9' }}>info@247assurecare.com</a>
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        Or call: <a href="tel:8474838999" style={{ color: '#1b8fc9' }}>(847)-483-8999</a>
                    </Typography>
                </Box>
            </Box>
        </div>
    );
};

export default CareersPage;